import * as yup from 'yup';

const schema = yup.object().shape({
  comment: yup.string().required('Comment field is required'),
});

export default schema;
